import React, { Fragment } from "react";
import { connect } from "react-redux";
import { openModal } from "ducks/matchingGifts";
import { FormattedNumber } from "react-intl";
import Countdown from "react-countdown";
import classNames from "classnames";
import MatchCompleteIcon from "shared/ui/svg-icons/MatchCompleteIcon";
import OrangeCheck from "shared/ui/svg-icons/OrangeCheck";
import { isEmptyValue } from "../../utils/utils";
import GivingButtonV2 from "shared/components/giving-form-v2/App/GivingButtonV2";

const Card = ({
  sectionId,
  entityId,
  campaign,
  matchingGift,
  currencyCode,
  onOpenModal,
}) => {
  const {
    id,
    title,
    image_filename: imageFilename,
    full_description: fullDescription,
    amount_raised: amountRaised,
    unique_donor_count: uniqueDonorCount,
    donation_count: donationCount,
    money_goal: moneyGoal,
    participation_goal: participationGoal,
    donation_goal: donationGoal,
    complete,
    expired,
    time_remaining: timeRemaining,
    active,
    type,
  } = matchingGift;

  const renderer = (props) => {
    return (
      <span>
        {props.formatted.hours}:{props.formatted.minutes}:{props.formatted.seconds}
      </span>
    );
  };

  return (
    <div className="card-elements">
      <div className={classNames({ "card-image-gradient": complete })}>
        {complete && <MatchCompleteIcon />}
        {active && (
          <div className="active">
            <div className="ellipse" />
            Active
          </div>
        )}
        <img
          aria-hidden="true"
          className={classNames("card-image", {
            "no-image": isEmptyValue(imageFilename.url),
          })}
          src={imageFilename.url}
        />
      </div>
      <h3 className="title">{title.slice(0, 49)}</h3>
      <div className="description">
        {fullDescription && `${fullDescription.slice(0, 25)}...`}
      </div>
      <button
        data-testid="t-Card-button"
        className="read-more"
        onClick={() => onOpenModal(`readMoreModal-${sectionId}`, matchingGift)}>
        READ MORE <i className="fa fa-chevron-right" />
      </button>
      <div className="card-row">
        <div className="dollars">
          {type === "Participation Based" ? (
            <Fragment>
              {uniqueDonorCount} / {participationGoal}
              <span className="italic-text"> Donors</span>
            </Fragment>
          ) : type === "Donation Based" ? (
            <Fragment>
              {donationCount} / {donationGoal}
              <span className="italic-text">
                {" "}
                {donationCount === 1 ? "Donation" : "Donations"}
              </span>
            </Fragment>
          ) : (
            <Fragment>
              <FormattedNumber
                value={amountRaised}
                currencyDisplay="symbol"
                currency={currencyCode}
                style="currency"
                minimumFractionDigits="0"
                maximumFractionDigits="0"
              />
              <span> / </span>
              <FormattedNumber
                value={moneyGoal}
                currencyDisplay="symbol"
                currency={currencyCode}
                style="currency"
                minimumFractionDigits="0"
                maximumFractionDigits="0"
              />
            </Fragment>
          )}
        </div>

        {timeRemaining > 0 && !complete && active && (
          <Fragment>
            <div className="countdown">
              <i className="fa fa-lg fa-clock-o" />
              &nbsp;
              <Countdown
                date={Date.now() + timeRemaining * 1000}
                daysInHours={true}
                renderer={renderer}
              />
            </div>
          </Fragment>
        )}
      </div>
      {(complete || expired) && (
        <div className="complete-icon">
          <OrangeCheck />
          &nbsp; Complete
        </div>
      )}
      {active && (
        <GivingButtonV2
          matchId={id}
          campaign={campaign}
          entityId={entityId}
          cssClasses={"match-gift-button"}
          buttonText={"Match Gift"}
        />
      )}
      {!active && !complete && !expired && (
        <div className="complete-icon">Starting Soon</div>
      )}
    </div>
  );
};

const mapStateToProps = ({ matchingGifts }) => {
  const { currentMatchingGift } = matchingGifts;

  return { currentMatchingGift };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onOpenModal: (selectedModal, currentMatchingGift, currentStep) =>
      dispatch(openModal(selectedModal, currentMatchingGift, currentStep)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Card);
